var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 20H13.6266C12.9211 19.1061 12.5 17.9772 12.5 16.75C12.5 13.8505 14.8505 11.5 17.75 11.5C19.4947 11.5 21.0406 12.3511 21.9953 13.6607C22 13.1517 22 12.5997 22 12C22 11.5581 22 10.392 21.9981 10H2.00189C2 10.392 2 11.5581 2 12C2 15.7712 2 17.6569 3.17157 18.8284C4.34315 20 6.22876 20 10 20Z",
    fill: "#005df2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16C5.25 15.5858 5.58579 15.25 6 15.25H10C10.4142 15.25 10.75 15.5858 10.75 16C10.75 16.4142 10.4142 16.75 10 16.75H6C5.58579 16.75 5.25 16.4142 5.25 16Z",
    fill: "#005df2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 14.5C16.5074 14.5 15.5 15.5074 15.5 16.75C15.5 17.9926 16.5074 19 17.75 19C18.9926 19 20 17.9926 20 16.75C20 15.5074 18.9926 14.5 17.75 14.5ZM14 16.75C14 14.6789 15.6789 13 17.75 13C19.8211 13 21.5 14.6789 21.5 16.75C21.5 17.5143 21.2713 18.2252 20.8787 18.818L21.7803 19.7197C22.0732 20.0126 22.0732 20.4874 21.7803 20.7803C21.4874 21.0732 21.0126 21.0732 20.7197 20.7803L19.818 19.8787C19.2252 20.2713 18.5143 20.5 17.75 20.5C15.6789 20.5 14 18.8211 14 16.75Z",
    fill: "#005df2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99484 4H14.0052C17.7861 4 19.6766 4 20.8512 5.11578C21.6969 5.91916 21.9337 7.07507 22 9V10H2V9C2.0663 7.07507 2.3031 5.91916 3.14881 5.11578C4.3234 4 6.21388 4 9.99484 4Z",
    fill: "#005df2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1eecd723103e04ce84a951a0108b27e7.svg";
export { ForwardRef as ReactComponent };